import { render, staticRenderFns } from "./OrganisationEditor.vue?vue&type=template&id=62129595&scoped=true&"
import script from "./OrganisationEditor.vue?vue&type=script&lang=js&"
export * from "./OrganisationEditor.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationEditor.vue?vue&type=style&index=0&id=62129595&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62129595",
  null
  
)

export default component.exports